<template lang='pug' src='./footer.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  computed: {
    props () {
      return this.$store.state.app['footer']
    },
    propsheader () {
      return this.$store.state.app['header']
    }
  },
  components: {
    Icon
  },
  data () {
    return {
      intersectionOptions2: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.70, 0.30] if you want a 60% offset!
      }
    }
  },
  methods: {
    onWaypoint2 ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        var element5 = document.getElementById('footer_id').querySelectorAll('.ornament')
        element5[0].classList.add('action')
      }

      if (going === this.$waypointMap.GOING_OUT) {
        var element6 = document.getElementById('footer_id').querySelectorAll('.ornament')
        element6[0].classList.remove('action')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?62ea75ae